import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MapItemComponent } from '@ui/shared/util-map';
import { DetailViewModule } from '@ui/shared/ui-detail-view';
import { ProjectListItemModel } from '../../definitions/project-list-item.model';

@Component({
    selector: 'ui-project-list-item-details',
    imports: [
        DetailViewModule,
    ],
    templateUrl: './project-list-item-details.component.html',
    styleUrl: './project-list-item-details.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectListItemDetailsComponent implements MapItemComponent<ProjectListItemModel> {
    public readonly mapItemTriggeredById = output<ProjectListItemModel>();

    public mapItem = input<ProjectListItemModel | undefined>();

    public hasSettings = computed(() => !!this.mapItem()?.ambience
        || !!this.mapItem()?.area
        || !!this.mapItem()?.poleCount
        || !!this.mapItem()?.usableArea
        || !!this.mapItem()?.restrictions,
    );

    public hasEnvironment = computed(() => !!this.mapItem()?.electricitySupply
        || !!this.mapItem()?.waterSupply
        || !!this.mapItem()?.nextPublicTransportStop
        || !!this.mapItem()?.nextCarPark,
    );
}
